module.exports = __webpack_public_path__ + "static/media/hull_color_style_0002.013f816a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hullColors/hull_color_style_0002.jpg
// module id = 620
// module chunks = 0